// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ea-6";
export var emphasizeQuantity = "_ea-3";
export var flatBottomCorners = "_ea-5";
export var productImage = "_ea-0";
export var quantityContainer = "_ea-2";
export var tooltip = "_ea-1";
export var wrapAndEllipsesOverflow = "_ea-4";